import React from "react";
import { Box } from "@mantine/core";
import StimulusImage from "./StimulusImage";
import { Stimulus } from "types/testTypes";

interface CPTTestBackgroundProps {
  stimuli: Stimulus[];
  isForAdult: boolean;
  style?: React.CSSProperties;
}

const CPTTestBackground: React.FC<CPTTestBackgroundProps> = ({ stimuli, style }) => {
  return (
    <Box
      w="100%"
      h="auto"
      pl={150}
      pr={150}
      pt={50}
      pb={50}
      style={{
        display: "grid",
        placeItems: "center",
        border: "2px solid var(--oculera-text)",
        ...style,
      }}
    >
      <Box
        w="100%"
        h="100%"
        mih={300}
        style={{ display: "grid", placeItems: "center", border: "2px solid var(--oculera-text)" }}
      >
        <StimulusImage stimuli={stimuli} style={{ width: "100%", height: "100%" }} />
      </Box>
    </Box>
  );
};

export default CPTTestBackground;
